import { render, staticRenderFns } from "./QuestionReset.vue?vue&type=template&id=4e1d7eb7&scoped=true&"
import script from "./QuestionReset.vue?vue&type=script&lang=js&"
export * from "./QuestionReset.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReset.vue?vue&type=style&index=0&id=4e1d7eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d7eb7",
  null
  
)

/* custom blocks */
import block0 from "./QuestionReset.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports